import { Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ListasService } from '../../../services/listas.service';
import { PaisDto } from '../../../dto/expediente/pais.dto';
import { TipoDocumentoDto } from '../../../dto/expediente/tipo-documento.dto';
import { TramiteDimarService } from '../../../services/traimte-dimar.service';
import { ArchivosFormDTO } from '../../../dto/expediente/archivos-form.dto';
import { AlertaModalService } from '../../../services/util/alerta-modal.service';
import { Constants } from '../../../constants/constants';
import { PersonaLoginDTO } from '../../../dto/util/persona.dto';
import { TramiteDimarDto } from '../../../dto/tramites/tramite-dimar.dto';
import { PersonaDto } from '../../../dto/tramites/persona.dto';
import { InfoPantallaDTO } from '../../../dto/util/infoPantallaDTO';
import { UtilService } from '../../../services/util.service';
import { TramiteService } from '../../../services/tramite.service';
import { TramiteDTO } from '../models/tramiteDTO';
import { AnexoPrecargaResponseDto } from '../../../dto/anexo/anexo-tramite.dto';
import { firstValueFrom } from 'rxjs';
import { Location } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';
import { TextTransformService } from '../../util/text-transform/text-transform.service';
import { ListaValorDto } from "../../../dto/expediente/lista-valor.dto";
import { DatosAdicionalesService } from '../../util/modal-datos/services/datos-adicionales.service';
import { DemandadoAuxDto } from "../../../dto/tramites/demandado-aux.dto";
import { LanguageService } from '../../../services/util/language.service';
import { PersonaComponent } from '../persona/persona.component';
import { PersonaAbogadoComponent } from '../persona-abogado/persona-abogado.component';

@Component({
  selector: 'app-creacion-dimar',
  templateUrl: './creacion-dimar.component.html',
  styleUrl: './creacion-dimar.component.scss',
})
export class CreacionDimarComponent implements OnInit, OnDestroy {
  @ViewChild('modalInformacion') modalInformacion!: ElementRef;
  @ViewChild(PersonaComponent) personaComponente!: PersonaComponent;
  @ViewChild(PersonaAbogadoComponent) abogadoComponente!: PersonaAbogadoComponent;
  idiomaActual: string = 'es';
  tramite: any;
  formularioInicial: FormGroup = new FormGroup({});
  proceeding: FormGroup = new FormGroup({});
  apoderadoForm: FormGroup = new FormGroup({});
  selectedOptions = '';
  // Listas
  countries: PaisDto[] = [];
  documentTypeList: TipoDocumentoDto[] = [];
  documentTypeListInteresada: TipoDocumentoDto[] = [];
  documentTypeListJuridica: TipoDocumentoDto[] = [];
  documentTypeListApoderado: TipoDocumentoDto[] = [];
  tiposSolicitante: ListaValorDto[] = [];
  tamaniosNave: ListaValorDto[] = [];

  requestClass = '';
  entidadId = Constants.ID_ENTIDAD_DIMAR;
  formDemanding: any = {};
  apoderado: any = {};
  interesado: any = {};
  objTipoSolicitante!: ListaValorDto;
  objTamanioEmbarcacion!: ListaValorDto;
  // string
  tipoPersona = '';
  tipoPersonaInteresado = '';

  dataUsuario: PersonaLoginDTO | undefined;

  // Información de la pantalla y guía interactiva
  infoPantalla!: InfoPantallaDTO;

  // Objetos para guardar los datos del trámite existente
  dataDemandado = {};
  dataApoderado = {};
  dataInteresado = {};
  idTramite!: number | null;

  demandadoAux: DemandadoAuxDto = {};

  // ID persona
  idDemandado!: number;
  idApoderado!: number;

  mostrarComponenteCarga: boolean = true;
  archivosCargados: AnexoPrecargaResponseDto[] = [];
  pesoTotalArchivosMB: number = 0;

  // ID embacación
  idEmbarcacion!: number;

  // Multilenguaje
  dimarText: any = {};
  comunText: any = {};
  alertaText: any = {};

  // Boolean
  estaMatriculado = false;
  mostrarParteInteresada = false;
  confirmacionEnvio: boolean = false;

  esColombiaParte = false;
  esColombiaParteInteresada = false;

  enviarCorreoDemandado: boolean = false;
  seleccionAceptoRechazoEnvio = false;
  proceso: string = '';
  entidad: string = '';
  tituloConDatos: string = '';
  idTipoDocumento: number | string = '';
  constructor(
    private readonly fb: FormBuilder,
    private readonly listService: ListasService,
    private readonly tramiteDimarService: TramiteDimarService,
    private readonly alertaModalService: AlertaModalService,
    private readonly router: Router,
    private readonly utilService: UtilService,
    private readonly tramiteService: TramiteService,
    private readonly location: Location,
    private readonly translate: TranslateService,
    private readonly textTransformService: TextTransformService,
    private readonly datosProvisionalesService: DatosAdicionalesService,
    private languageService: LanguageService,
  ) { }

  ngOnInit(): void {
    this.idiomaActual = this.languageService.getCurrentLanguage();

    this.languageService.currentLanguage$.subscribe(lang => {
      this.idiomaActual = lang;
    });
    this.tramiteService.obtenerNombreEntidadPorId(6).subscribe({
      next: (data) => {
        this.entidad = data.entidad;
        this.proceso = data.nombreCompletoTramite || '';
      },
      error: (err) => console.error('Error al obtener entidad y proceso:', err),
    });
    this.translate.stream('alertas').forEach(text => {
      for (const key of Object.keys(text)) {
        this.alertaText[key] = text[key];
      }
    });
    // Evento de recargar o cerrar pestaña
    //window.addEventListener('beforeunload', this.unloadNotification);
    // Consultar si existe un trámite pendiente
    const infoInicioSesion = JSON.parse(
      sessionStorage.getItem(Constants.USER_INFORMATION_STORAGE) ?? '{}'
    );

    // Se valida si existe un trámite pendiente por completar
    this.tramiteService
      .consultarTramitePendiente(
        infoInicioSesion.idUsuario,
        Constants.DIMAR_COSIMAR
      )
      .subscribe(resp => {
        if ((resp as { Id: number }).Id !== null) {
          // Se consume el servicio que obtiene el detalle del trámite
          this.alertaModalService.confirmacion(
            this.alertaText['continuar-solicitud-almacenada'],
            '',
            () => {
              this.mostrarComponenteCarga = false;
              this.consultarTramitePorID(resp.Id);
              this.dataUsuario = undefined;
            },
            () => {
              this.idTramite = null;
              this.dataUsuario = JSON.parse(
                sessionStorage.getItem(Constants.USER_INFORMATION_STORAGE)!
              );
            },
            true
          );
        } else {
          this.idTramite = null;
          this.dataUsuario = JSON.parse(
            sessionStorage.getItem(Constants.USER_INFORMATION_STORAGE)!
          );
        }
      });
    this.loadListCountries();
    this.loadDocumentTypeList();
    this.embarcacionValidations();
    // Lista tipos de solicitante
    this.listarTiposSolicitante();
    this.listarTamaniosNave();
    // Formulario inicial
    this.formularioInicial = this.fb.group({
      tipoSolicitante: ['', Validators.required]
    });
    // Formulario de apoderado
    this.apoderadoForm = this.fb.group({
      numeroTarjetaProfesional: [
        '',
        [
          Validators.minLength(3),
          Validators.maxLength(12),
          Validators.pattern(Constants.REGEX_TELEFONO),
        ],
      ],
      telefonoApoderado: [
        '',
        [
          Validators.minLength(6),
          Validators.maxLength(15),
          Validators.pattern(/^\d+$/),
        ],
      ],
    });
    const user_type = JSON.parse(
      sessionStorage.getItem(Constants.USER_TYPE) ?? '{}');
    if (user_type.Nombre === 'Abogado') {
      this.dataUsuario = JSON.parse(
        sessionStorage.getItem(Constants.USER_INFORMATION_STORAGE)!
      );
      this.getDataUsuario(this.dataUsuario?.idPersona!)
    }

    // Se asigna información a InfoPantallaDTO
    this.infoPantalla = {
      tituloPantalla:
        'Inicio de Proceso de resolución de conflictos por siniestro marítimo en la entidad ' +
        'Dirección Marítima',
      descripcionPantalla:
        'En esta pantalla usted podrá iniciar un proceso de resolución de conflictos por ' +
        'siniestro marítimo en la Dirección Marítima',
      pasos: [],
      change: async op =>
        await this.guardarAntesDeSalir(
          this.alertaModalService,
          this.location,
          op
        ),
    };
    this.utilService.changeInfoPantalla(this.infoPantalla);
    this.translate.stream('tramites').forEach(text => {
      for (const key of Object.keys(text)) {
        this.dimarText[key] = text[key];
      }
    });
    this.translate.stream('comun-label').forEach(text => {
      for (const key of Object.keys(text)) {
        this.comunText[key] = text[key];
      }
    });
  }

  // Se consume el servicio de listas para obtener los tipos de solicitante
  listarTiposSolicitante() {
    this.listService.listaValor(Constants.LISTA_TIPOS_SOLICITANTE).subscribe((resp) => {
      this.tiposSolicitante = resp;
    })
  }
  listarTamaniosNave() {
    this.listService.listaValor(Constants.TAMANIOS_NAVE_DIMAR).subscribe((resp) => {
      this.tamaniosNave = resp;
    })
  }
  async guardarAntesDeSalir(
    alertas: AlertaModalService,
    loc: Location,
    op?: () => void
  ) {
    await alertas.confirmacion(
      this.alertaText['recordatorio-campos-obligatorios'],
      this.alertaText['almacenar-progeso-solicitud'],
      async () => {
        try {
          const response = await this.onSubmitSave();
          if (response.success) {
            if (op) {
              op();
            } else {
              loc.back();
            }
          } else {
            await alertas.confirmacion(
              this.alertaText['salir-o-continuar-diligenciando'],
              this.alertaText['datos-no-guardados'],
              () => {
                if (op) {
                  op();
                } else {
                  loc.back();
                }
              },
              () => {
                // El usuario decide continuar diligenciando
              }
            );
          }
        } catch (error) {
          // Manejo de errores de llamada al servicio
          await alertas.confirmacion(
            this.alertaText['salir-o-continuar-diligenciando'],
            this.alertaText['datos-no-guardados'],
            () => {
              if (op) {
                op();
              } else {
                loc.back();
              }
            },
            () => {
              // El usuario decide continuar diligenciando
            }
          );
        }
      },
      () => {
        if (op) {
          op();
        } else {
          loc.back();
        }
      }
    );
  }

  async ngOnDestroy() {
    // Evento de recargar o cerrar pestaña
    //window.removeEventListener('beforeunload', this.unloadNotification);
  }
  // Se consume el servicio de consultar el detalle del trámite según el ID
  consultarTramitePorID(id: number) {
    this.idTramite = id;
    this.tramiteService.cargarTramitePendiente(id).subscribe((resp: TramiteDTO) => {
      if (resp) {
        if (resp.tipoSolicitante) {
          this.formularioInicial.get('tipoSolicitante')?.setValue(resp.tipoSolicitante.Id);
          // Se obtiene el ID de la opción lesionado
          const idLesionado = this.tiposSolicitante.find(
            item => item.Codigo == Constants.CODIGO_LESIONADO
          )?.Id;

          // Se obtiene el ID de la opción terceros interesados
          const idTercero = this.tiposSolicitante.find(
            item => item.Codigo == Constants.CODIGO_TERCEROS
          )?.Id;

          // Se valida si la opción seleccionada es lesionado o tercero interesado
          if (resp.tipoSolicitante.Id == idLesionado || resp.tipoSolicitante.Id == idTercero) {
            this.mostrarParteInteresada = true;
            // Se asigna el tipo de persona natural por defecto al interesado
            if (!this.formDemanding) {
              this.formDemanding = { data: {} };
            }
            if (!this.formDemanding.data) {
              this.formDemanding.data = {};
            }
            this.formDemanding.data.tipoDePersona = 1;
          } else {
            this.mostrarParteInteresada = false;
          }
        }
        if (resp.anexos) {
          resp.anexos.forEach(anexo => {
            this.idTipoDocumento = anexo.tipoId;
          });
          this.archivosCargados = resp.anexos;
        }
        this.mostrarComponenteCarga = true;

        this.idEmbarcacion = resp.embarcacion.id;
        resp.embarcacionMatriculada !== null ? this.proceeding.controls['embarcacionMatriculada'].setValue(resp.embarcacionMatriculada)
          : this.proceeding.controls['embarcacionMatriculada'].setValue(null);
        if (typeof resp.embarcacionMatriculada === 'string') {
          this.estaMatriculado = resp.embarcacionMatriculada === 'true' ? true : false;
        } else {
          this.estaMatriculado = resp.embarcacionMatriculada;
        }
        resp.embarcacion = this.textTransformService.transformarAMayusculas(resp.embarcacion)
        resp.embarcacion.nombreEmbarcacion !== '' ? this.proceeding.controls['nombreEmbarcacion'].setValue(resp.embarcacion.nombreEmbarcacion)
          : this.proceeding.controls['nombreEmbarcacion'].setValue(null);
        resp.embarcacion.matriculaEmbarcacion !== '' ? this.proceeding.controls['matriculaEmbarcacion'].setValue(resp.embarcacion.matriculaEmbarcacion)
          : this.proceeding.controls['matriculaEmbarcacion'].setValue(null);
        const actaProtesta = this.textTransformService.transformarAMayusculas(resp)
        resp.actaProtesta !== '' ? this.proceeding.controls['actaProtesta'].setValue(actaProtesta.actaProtesta)
          : this.proceeding.controls['actaProtesta'].setValue(null);
        resp.escritoVinculacion !== '' ? this.proceeding.controls['escritoVinculacion'].setValue(resp.escritoVinculacion)
          : this.proceeding.controls['escritoVinculacion'].setValue(null);
        resp.apoderado.tarjetaProfesional !== '' ? this.apoderadoForm.controls['numeroTarjetaProfesional'].setValue(resp.apoderado.tarjetaProfesional)
          : this.apoderadoForm.controls['numeroTarjetaProfesional'].setValue(null);
        resp.apoderado.telefonoPrincipal !== '' ? this.apoderadoForm.controls['telefonoApoderado'].setValue(resp.apoderado.telefonoPrincipal)
          : this.apoderadoForm.controls['telefonoApoderado'].setValue(null);
        if (resp.demandado.length > 0) {
          this.idDemandado = resp.demandado[0].id;
          resp.demandado[0] = this.textTransformService.transformarAMayusculas(resp.demandado[0])
          const municipioDemandado = resp.demandado[0].municipio?.id && resp.demandado[0].municipio.id !== null
            ? resp.demandado[0].municipio.id
            : null;
          this.idDemandado = resp.demandado[0].id;
          resp.demandado[0] = this.textTransformService.transformarAMayusculas(resp.demandado[0])
          this.dataDemandado = {
            tipoDePersona: resp.demandado[0].idTipoPersona ? resp.demandado[0].idTipoPersona : null,
            email: resp.demandado[0].correoElectronico ? resp.demandado[0].correoElectronico : null,
            primerNombre: resp.demandado[0].primerNombre ? resp.demandado[0].primerNombre
              : resp.demandado[0].razonSocial,
            segundoNombre: resp.demandado[0].segundoNombre ? resp.demandado[0].segundoNombre : null,
            primerApellido: resp.demandado[0].primerApellido ? resp.demandado[0].primerApellido : null,
            segundoApellido: resp.demandado[0].segundoApellido ? resp.demandado[0].segundoApellido : null,
            tipoDocumento: resp.demandado[0].idTipoIdentificacion ? resp.demandado[0].idTipoIdentificacion : null,
            identificacion: resp.demandado[0].identificacion != null ? resp.demandado[0].identificacion : null,
            pais: resp.demandado[0].municipio.idPais ? resp.demandado[0].municipio.idPais : null,
            departmento: resp.demandado[0].municipio.idDepartamento ? resp.demandado[0].municipio.idDepartamento : null,
            municipio: municipioDemandado,
            otroDepartamento: resp.demandado[0].otroDepartamento ? resp.demandado[0].otroDepartamento : null,
            otroMunicipio: resp.demandado[0].otroMunicipio ? resp.demandado[0].otroMunicipio : null,
            direccion: resp.demandado[0].direccionPersona.length > 0 && resp.demandado[0].direccionPersona[0].direccionNotificacion ?
              resp.demandado[0].direccionPersona[0].direccionNotificacion : null,
          }
          if (!this.esColombiaParte) {
            this.esColombiaParte =
              this.countries.find(
                k => k.Id == resp.demandado[0].municipio.idPais
              )?.Codigo == Constants.CODIGO_COLOMBIA;
          }
        }
        let apoderadoData = null;

        if (Array.isArray(resp.apoderado)) {
          apoderadoData = resp.apoderado.length > 0 ? resp.apoderado[0] : null;
        } else if (resp.apoderado && typeof resp.apoderado === 'object') {
          apoderadoData = resp.apoderado;
        }

        if (apoderadoData) {
          this.idApoderado = apoderadoData.id;

          this.dataApoderado = {
            tipoDePersona: apoderadoData.idTipoPersona ?? null,
            email: apoderadoData.correoElectronico ?? null,
            primerNombre: apoderadoData.primerNombre || apoderadoData.razonSocial,
            segundoNombre: apoderadoData.segundoNombre ?? null,
            primerApellido: apoderadoData.primerApellido ?? null,
            segundoApellido: apoderadoData.segundoApellido ?? null,
            tipoDocumento: apoderadoData.idTipoIdentificacion ?? null,
            identificacion: apoderadoData.identificacion ?? null,
            pais: apoderadoData.municipio?.idPais ?? null,
            departmento: apoderadoData.municipio?.idDepartamento ?? null,
            municipio: apoderadoData.municipio?.id ?? null,
            otroDepartamento: apoderadoData.otroDepartamento ?? null,
            otroMunicipio: apoderadoData.otroMunicipio ?? null,
            direccion: apoderadoData.direccionPersona?.length > 0
              ? apoderadoData.direccionPersona[0].direccionNotificacion
              : null,
          };
          this.apoderadoForm.get('numeroTarjetaProfesional')?.setValue(
            apoderadoData.tarjetaProfesional ?? '');
          this.apoderadoForm.get('telefonoApoderado')?.setValue(apoderadoData.telefonoPrincipal);
        }

        if (resp.interesado) {
          this.dataInteresado = {
            tipoDePersona: resp.interesado.idTipoPersona ? Number(resp.interesado.idTipoPersona) : null,
            email: resp.interesado.correoElectronico ? resp.interesado.correoElectronico : null,
            primerNombre: resp.interesado.primerNombre ? resp.interesado.primerNombre
              : resp.interesado.razonSocial,
            segundoNombre: resp.interesado.segundoNombre ? resp.interesado.segundoNombre : null,
            primerApellido: resp.interesado.primerApellido ? resp.interesado.primerApellido : null,
            segundoApellido: resp.interesado.segundoApellido ? resp.interesado.segundoApellido : null,
            tipoDocumento: resp.interesado.idTipoIdentificacion ? resp.interesado.idTipoIdentificacion : null,
            identificacion: resp.interesado.identificacion ? resp.interesado.identificacion : null,
            pais: resp.interesado.idPais ? resp.interesado.idPais : null,
            departmento: resp.interesado.idDepartamento ? resp.interesado.idDepartamento : null,
            municipio: resp.interesado.idMunicipio ? resp.interesado.idMunicipio : null,
            otroDepartamento: resp.interesado.otroDepartamento ? resp.interesado.otroDepartamento : null,
            otroMunicipio: resp.interesado.otroMunicipio ? resp.interesado.otroMunicipio : null,
            direccion: resp.interesado.direccionPersona?.length > 0 && resp.interesado.direccionPersona[0].direccionNotificacion ?
              resp.interesado.direccionPersona[0].direccionNotificacion : null,
          }
          this.esColombiaParteInteresada =
            this.countries.find(
              k => k.Id == resp.interesado.idPais
            )?.Codigo == Constants.CODIGO_COLOMBIA;
        }
        if (this.esColombiaParte || this.esColombiaParteInteresada) {
          this.proceeding.get('tamanioNave')?.setValue(resp.embarcacion?.tamanioEmbarcacion?.Id);
        }
      }
    })
  }


  loadListCountries() {
    this.listService.getCountryList().subscribe(countries => {
      this.countries = countries;
    });
  }

  embarcacionValidations() {
    this.proceeding = this.fb.group({
      embarcacionMatriculada: ['', Validators.required],
      nombreEmbarcacion: [
        '',
        [
          Validators.maxLength(30),
          Validators.pattern(Constants.REGEX_ALPHANUMERIC_WITHOUT_SPACES),
        ],
      ],
      matriculaEmbarcacion: [
        '',
        [
          Validators.maxLength(20),
          Validators.minLength(9)
        ],
      ],
      tamanioNave: ['', []],
      actaProtesta: [
        '',
        [
          Validators.maxLength(2000),
          Validators.pattern(Constants.REGEX_ACTA_PROTESTA),
        ],
      ],
      escritoVinculacion: ['', [Validators.maxLength(600)]],
      tipoAnexo: ['', [Validators.required]],
      archivos: [null],
    });
  }

  loadDocumentTypeList() {
    this.listService
      .getDocumentTypeListByPersonType('1', this.entidadId)
      .subscribe(documentTypeList => {
        this.documentTypeList = documentTypeList;
        this.documentTypeListInteresada = documentTypeList;
        this.documentTypeListApoderado = documentTypeList.filter(
          doc => doc.Tipo_Documento !== 'NA' && doc.Tipo_Documento !== 'TP'
        );
      });
    this.listService
      .getDocumentTypeListByPersonType('2', this.entidadId)
      .subscribe(documentTypeList => {
        this.documentTypeListJuridica = documentTypeList;
      });
  }

  handleFormData(event: { valid: boolean; data: any; }) {
    this.formDemanding = event;
    this.demandadoAux = event.data;
    if (event.data?.tipoDePersona) {
      this.tipoPersona =
        event.data?.tipoDePersona == Constants.TYPE_OF_PERSON_NATURAL
          ? Constants.LABEL_PERSONA_NATURAL
          : Constants.LABEL_PERSONA_JURIDICA;
    }
    if (event.data?.pais) {
      this.esColombiaParte = this.countries.find(k => k.Id == event.data?.pais)?.Codigo == Constants.CODIGO_COLOMBIA
    } else {
      this.esColombiaParte = false;
    }
  }

  handleFormDataAttorney(event: { valid: boolean; data: any; }) {
    this.apoderado = event;
  }

  handleFormDataInterested(event: { valid: boolean; data: any }) {
    this.interesado = event;
    if (event.data?.tipoDePersona) {
      this.tipoPersonaInteresado =
        event.data?.tipoDePersona == Constants.TYPE_OF_PERSON_NATURAL
          ? Constants.LABEL_PERSONA_NATURAL
          : Constants.LABEL_PERSONA_JURIDICA;
    }
    if (event.data?.pais) {
      this.esColombiaParteInteresada = this.countries.find(k => k.Id == event.data?.pais)?.Codigo == Constants.CODIGO_COLOMBIA
    } else {
      this.esColombiaParteInteresada = false;
    }
  }
  onChangeRequestClass(event: any) {
    this.requestClass = event.target.value;
    this.proceeding?.controls['requestClass'].setValue(event.target.value);
  }

  setFilesFormValue(event: ArchivosFormDTO) {
    this.proceeding.patchValue({
      archivos: event.Archivos,
      tipoAnexo: event.tipoAnexo,
    });
    const totalBytes = Array.from(event.Archivos).reduce((acc: number, file: File) => acc + file.size, 0);
    this.pesoTotalArchivosMB = totalBytes / Constants.BYTES_POR_MB;
    // this.isButtonEnabled = () => event.Archivos && event.Archivos.length > 0;
  }

  onCheckboxChange(event: Event): void {
    this.confirmacionEnvio = (event.target as HTMLInputElement).checked;
  }


  isButtonEnabled(): boolean {
    let enabledButtonProceeding: boolean = false;
    let enabledButtonDemanding: boolean = false;
    let enabledButtonApoderado: boolean = false;
    if (this.mostrarParteInteresada) {
      if (this.interesado.valid) {
        enabledButtonDemanding = true
      }
    } else {
      if (this.formDemanding.valid) {
        enabledButtonDemanding = true
      }
    }

    if (this.apoderado.valid) {
      enabledButtonApoderado = true;
    }
    if (this.proceeding.valid) {
      enabledButtonProceeding = true;
    }
    const isEnabled = enabledButtonProceeding && enabledButtonDemanding && enabledButtonApoderado && +this.pesoTotalArchivosMB > 0;
    if (!isEnabled) {
      this.confirmacionEnvio = false;
    }
    return isEnabled;
  }

  async onSubmit() {

    if (!this.archivosValidos()) {
      this.alertaModalService.error(
        this.alertaText['error'],
        this.alertaText['archivos_obligatorios']
      );
      return;
    }

    if (!this.isButtonEnabled()) {
      this.markFormsAsTouched();
      this.alertaModalService.error(
        this.alertaText['error'],
        this.alertaText['form_invalid']
      );
      return;
    }

    const formData = await this.createFormData('true');

    this.tramiteDimarService
      .postCrearTramiteDimar(formData)
      .subscribe(response => {
        if (response.success) {
          const mensajeConEntidad = this.alertaText['dimar-alertas']['tramite-enviado'].replace('{{entidad}}', this.entidad);
          this.alertaModalService.exito(
            this.alertaText['expediente-creado'],
            mensajeConEntidad
          );
          this.router.navigate(['/expediente']);
        } else {
          this.alertaModalService.error(response.message);
        }
      });
  }

  private archivosValidos(): boolean {
    const archivos = this.proceeding.get('archivos')?.value;
    return archivos && archivos.length > 0;
  }

  markFormsAsTouched() {
    if (this.mostrarParteInteresada) {
      if (this.personaComponente) {
        this.personaComponente.marcarTodoComoTocado();
      }
    } else {
      if (this.personaComponente) {
        this.personaComponente.marcarTodoComoTocado();
      }
    }
    if (this.apoderado) {
      if (this.abogadoComponente) {
        this.abogadoComponente.marcarTodoComoTocado();
      }
    }
    this.formularioInicial.markAllAsTouched();
    this.proceeding?.markAllAsTouched();
  }

  async onSubmitSave(): Promise<{ success: boolean; message?: string }> {
    const formData: FormData = await this.createFormData('false');
    if (this.tramite) {
      this.setUpdateData(formData, true);
    }
    try {
      this.tramite = await firstValueFrom(
        this.tramiteDimarService.postCrearTramiteDimar(formData)
      );
      if (this.tramite.success) {
        const mensajePersonalizado = this.alertaText['dimar-alertas']['tramite-enviado-mensaje']
          .replace('{{entidad}}', this.entidad)
          .replace('{{proceso}}', this.proceso);
        await this.alertaModalService.exito(
          this.alertaText['solicitud-pendiente-finalizar'],
          mensajePersonalizado
        );
        return { success: true };
      } else {
        return { success: false };
      }
    } catch (error) {
      return { success: false, message: 'Error al guardar' };
    }
  }

  async createFormData(esEnviar: string): Promise<FormData> {
    const formData = new FormData();
    let id = 0;
    if (this.dataUsuario === undefined) {
      id = JSON.parse(
        sessionStorage.getItem(Constants.USER_INFORMATION_STORAGE)!
      ).idUsuario;
    }
    const tipoPersona = +this.formDemanding.data.tipoDePersona;
    let municipioDemandado: any = {};
    const paisDemandado = this.formDemanding.data['pais'];

    // Siempre establecer el país
    if (paisDemandado) {
      municipioDemandado.idPais = paisDemandado;
    }

    // Lógica diferente para Colombia vs otros países
    if (paisDemandado == Constants.ID_COLOMBIA) {
      // Para Colombia: usar departamento y municipio normal
      if (this.formDemanding.data['departmento']) {
        municipioDemandado.idDepartamento = this.formDemanding.data['departmento'];
      }
      if (this.formDemanding.data['municipio']) {
        municipioDemandado.id = this.formDemanding.data['municipio'];
      }
      // LIMPIAR otroDepartamento y otroMunicipio cuando es Colombia
      this.formDemanding.data['otroDepartamento'] = '';
      this.formDemanding.data['otroMunicipio'] = '';
    } else {
      // Para otros países: limpiar departamento/municipio normal
      municipioDemandado.idDepartamento = undefined;
      municipioDemandado.id = undefined;
    }
    let municipioApoderado: any = {};
    if (this.apoderado.data['municipio']) {
      municipioApoderado.id = this.apoderado.data['municipio'];
    }
    if (this.apoderado.data['pais']) {
      municipioApoderado.idPais = this.apoderado.data['pais'];
    }
    if (this.apoderado.data['departmento']) {
      municipioApoderado.idDepartamento = this.apoderado.data['departmento'];
    }
    const demandante: PersonaDto = {
      id: this.idDemandado ? this.idDemandado : null,
      correoElectronico: this.formDemanding.data['email'],
      identificacion: this.formDemanding.data['identificacion'],
      municipio: Object.keys(municipioDemandado).length > 0 ? municipioDemandado : undefined,
      otroDepartamento: this.formDemanding.data['otroDepartamento'],
      otroMunicipio: this.formDemanding.data['otroMunicipio'],
      primerApellido: tipoPersona === 1 ? this.formDemanding.data['primerApellido'] : undefined,
      primerNombre: tipoPersona === 1 ? this.formDemanding.data['primerNombre'] : undefined,
      segundoApellido: tipoPersona === 1 ? this.formDemanding.data['segundoApellido'] : undefined,
      segundoNombre: tipoPersona === 1 ? this.formDemanding.data['segundoNombre'] : undefined,
      razonSocial: tipoPersona === 1 ? undefined : this.formDemanding.data['primerNombre'],
      direccionPersona: [
        { direccionNotificacion: this.formDemanding.data['direccion'] },
      ],
      idTipoIdentificacion: this.formDemanding.data['tipoDocumento'],
      idTipoPersona: this.formDemanding.data['tipoDePersona'],
    };
    const apoderado: PersonaDto = {
      id: this.idApoderado ? this.idApoderado : null,
      correoElectronico: this.apoderado.data['email'],
      identificacion: this.apoderado.data['identificacion'],
      municipio: Object.keys(municipioApoderado).length > 0 ? municipioApoderado : undefined,
      otroDepartamento: this.apoderado.data['otroDepartamento'],
      otroMunicipio: this.apoderado.data['otroMunicipio'],
      primerApellido: this.apoderado.data['primerApellido'],
      primerNombre: this.apoderado.data['primerNombre'],
      segundoApellido: this.apoderado.data['segundoApellido'],
      segundoNombre: this.apoderado.data['segundoNombre'],
      direccionPersona: [
        { direccionNotificacion: this.apoderado.data['direccion'] },
      ],
      idTipoIdentificacion: this.apoderado.data['tipoDocumento'],
      idTipoPersona: Constants.TIPO_PERSONA.NATURAL,
      tarjetaProfesional: this.apoderadoForm.controls['numeroTarjetaProfesional'].value,
      telefonoPrincipal: this.apoderadoForm.controls['telefonoApoderado'].value
    }
    let interesado: PersonaDto;
    if (this.mostrarParteInteresada) {

      interesado = {
        correoElectronico: this.interesado.data['email'],
        identificacion: this.interesado.data['identificacion'],
        municipio: {
          id: this.interesado.data['municipio'],
          idPais: this.interesado.data['pais'],
          idDepartamento: this.interesado.data['departmento']
        },
        otroDepartamento: this.interesado.data['otroDepartamento'],
        otroMunicipio: this.interesado.data['otroMunicipio'],
        primerApellido: this.interesado.data['primerApellido'],
        primerNombre: this.interesado.data['primerNombre'],
        segundoApellido: this.interesado.data['segundoApellido'],
        segundoNombre: this.interesado.data['segundoNombre'],
        direccionPersona: [
          { direccionNotificacion: this.interesado.data['direccion'] },
        ],
        idTipoIdentificacion: this.interesado.data['tipoDocumento'],
        idTipoPersona: this.interesado.data['tipoDePersona'],
      }
    } else {
      interesado = {};
    }

    this.tiposSolicitante.map(tipo => {
      if (tipo.Id == this.formularioInicial.get('tipoSolicitante')?.value) {
        this.objTipoSolicitante = tipo;
      }
    })
    this.tamaniosNave.map(tamanio => {
      if (tamanio.Id == this.proceeding.get('tamanioNave')?.value) {
        this.objTamanioEmbarcacion = tamanio;
      }
    })
    const esLesionadoOTercero =
      this.objTipoSolicitante &&
      (this.objTipoSolicitante.Valor === Constants.VALORES_TIPO_SOLICITANTE.LESIONADO ||
        this.objTipoSolicitante.Valor === Constants.VALORES_TIPO_SOLICITANTE.TERCEROS_INTERESADOS);
    const tramite: TramiteDimarDto = {

      id: this.idTramite ? this.idTramite : null,

      actaProtesta: esLesionadoOTercero ? undefined : this.proceeding.value['actaProtesta'],
      escritoVinculacion: esLesionadoOTercero ? this.proceeding.value['escritoVinculacion'] : undefined,
      embarcacion: {
        id: this.idEmbarcacion ? this.idEmbarcacion : null,
        matriculaEmbarcacion: this.proceeding.value['matriculaEmbarcacion'],
        nombreEmbarcacion: this.proceeding.value['nombreEmbarcacion'],
        tamanioEmbarcacion: this.objTamanioEmbarcacion
          ? {
            Id: this.objTamanioEmbarcacion.Id,
            Codigo: this.objTamanioEmbarcacion.Codigo,
            Estado: this.objTamanioEmbarcacion.Estado,
            Nombre_lista: this.objTamanioEmbarcacion.Nombre_lista,
            Otro_valor: this.objTamanioEmbarcacion.Otro_valor,
            Valor: this.objTamanioEmbarcacion.Valor
          }
          : undefined
      },
      embarcacionMatriculada: this.proceeding.value['embarcacionMatriculada'],
      tipoAnexo: Number(this.proceeding.value['tipoAnexo']),
      demandante: [demandante],
      apoderado: apoderado,
      interesado: interesado,
      tipoSolicitante: this.objTipoSolicitante
        ? {
          Id: this.objTipoSolicitante.Id,
          Codigo: this.objTipoSolicitante.Codigo,
          Estado: this.objTipoSolicitante.Estado,
          Nombre_lista: this.objTipoSolicitante.Nombre_lista,
          Otro_valor: this.objTipoSolicitante.Otro_valor,
          Valor: this.objTipoSolicitante.Valor
        }
        : undefined,
      tieneApoderado: true,
      usuario: {
        id: this.dataUsuario?.idUsuario ? this.dataUsuario?.idUsuario : id,
      },
      idioma: this.idiomaActual,
    };
    formData.append('tramite', JSON.stringify(tramite));
    formData.append('enviar', esEnviar);
    formData.append('enviarCorreoDemandado', String(this.enviarCorreoDemandado ?? false));
    if (!this.idTramite && this.proceeding.value.archivos) {
      // Trámite nuevo → subir todos los archivos
      Array.from(this.proceeding.value.archivos as FileList).forEach(
        (file: File) => formData.append('archivos', file)
      );
    }
    else if (this.idTramite && this.proceeding.value.archivos) {

      const archivosNuevos = Array.from(this.proceeding.value.archivos as FileList);
      const archivosAntiguos = this.archivosCargados || [];

      archivosNuevos.forEach(archivoNuevo => {

        // Buscar si ya existe en los cargados
        const esElMismoArchivo = archivosAntiguos.some(archivoAntiguo =>
          archivoAntiguo.nombreArchivo === archivoNuevo.name &&
          +archivoAntiguo.tamano === archivoNuevo.size
        );

        // Si NO existe → agregarlo al formData
        if (!esElMismoArchivo) {
          formData.append('archivos', archivoNuevo);
        }
      });
    }

    return formData;
  }

  setUpdateData(formData: FormData, enviar = false): void {
    const tramiteData = this.tramite?.data;
    if (!tramiteData) {
      return;
    }

    const tramiteFields = {
      idTramite: tramiteData.Id,
      idPersonaNatural: tramiteData.idPersonaNatural,
      idPersonaJuridica: tramiteData.idPersonaJuridica,
      idEmbarcacion: tramiteData.Id_Embarcacion,
      idPersona: tramiteData.Id_Investigado,
    };

    Object.entries(tramiteFields).forEach(([key, value]) => {
      if (value && !formData.has(key)) {
        formData.append(key, value);
      }
    });

    if (enviar && !formData.has('enviar')) {
      formData.append('enviar', 'true');
    }
  }

  // Se valida que el primer nombre y el primer apellido del investigado estén diligenciados
  validarInvestigado(): boolean {
    // Se valida si el objeto está vacío
    if (!this.formDemanding || Object.keys(this.formDemanding).length === 0) {
      return false;
    }
    return true;
    // if (this.formDemanding.data['tipoDePersona'] === 1) {
    //   if (
    //     this.formDemanding.data['primerNombre'] &&
    //     this.formDemanding.data['primerApellido']
    //   ) {
    //     return true;
    //   } else {
    //     return false;
    //   }
    // } else {
    //   return true;
    // }
  }

  async getMunicipioCountrie(idPais: number): Promise<number> {
    try {
      const countries = await firstValueFrom(this.listService.getDepartmentList(idPais));
      const municipalities = await firstValueFrom(this.listService.getMunicipalityList(countries[0].Id));
      return municipalities[0].Id;
    } catch (error) {
      // console.error("Error al obtener el municipio:", error);
      return 0;
    }
  }

  // Función que verifica si la embarcación está matriculada
  verificar(event: any) {
    event.target.value == 'true' ? this.estaMatriculado = true : this.estaMatriculado = false;
  }

  // Función que valida el tipo de solicitante seleccionado
  validarSolicitante(event: any) {
    // Se obtiene el ID de la opción lesionado
    const idLesionado = this.tiposSolicitante.find(
      item => item.Codigo == Constants.CODIGO_LESIONADO
    )?.Id;

    // Se obtiene el ID de la opción terceros interesados
    const idTercero = this.tiposSolicitante.find(
      item => item.Codigo == Constants.CODIGO_TERCEROS
    )?.Id;
    // Se valida si la opción seleccionada es lesionado o tercero interesado
    this.mostrarParteInteresada = event.target.value == idLesionado || event.target.value == idTercero;
    let acta = this.proceeding.get('actaProtesta');
    let escrito = this.proceeding.get('escritoVinculacion');
    if (this.mostrarParteInteresada) {
      acta?.clearValidators();
      acta?.updateValueAndValidity();
      escrito?.setValidators([
        Validators.required,
        Validators.maxLength(600),
      ]);
      escrito?.updateValueAndValidity();
    } else {
      acta?.setValidators([
        Validators.required,
        Validators.maxLength(2000),
        Validators.pattern(Constants.REGEX_ACTA_PROTESTA),
      ]);
      acta?.updateValueAndValidity();

      escrito?.clearValidators();
      escrito?.updateValueAndValidity();
    }
  }

  // Función que abre el modal con la información del campo escrito de vinculación
  abrirModal() {
    this.modalInformacion.nativeElement.click();
  }

  getDataUsuario(idPersona: number) {
    this.datosProvisionalesService
      .getDataAbogado(idPersona)
      .subscribe((response: any) => {
        this.apoderadoForm.get('numeroTarjetaProfesional')?.setValue(response.datoAdicionalAbogado?.Tarjeta_Profesional ?? '');
      })
  }

  get correoDemandado(): string {
    return this.demandadoAux?.email ?? '';
  }

  get nombreDemandado(): string {
    const d = this.demandadoAux;
    return `${d.primerNombre ?? ''} ${d.segundoNombre ?? ''} ${d.primerApellido ?? ''} ${d.segundoApellido ?? ''}`.trim();
  }

  get pesoArchivos(): number {
    return this.pesoTotalArchivosMB;
  }

  rechazarEnvio() {
    this.seleccionAceptoRechazoEnvio = true;
    this.enviarCorreoDemandado = false;
    this.alertaModalService.exito(
      this.comunText['accion-cancelada'],
      this.comunText['rechazo-envio']
    );
  }

  aceptarEnvio() {
    this.seleccionAceptoRechazoEnvio = true;
    this.enviarCorreoDemandado = true;
    this.alertaModalService.exito(
      this.comunText['envio-confirmado'],
      this.comunText['acepta-copia']
    );
  }
}
